import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=59090bff&scoped=true&"
import script from "./DeleteAccount.vue?vue&type=script&lang=js&"
export * from "./DeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=59090bff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59090bff",
  null
  
)

export default component.exports